import * as types from "../constants/actionConstants";

export function addDrawerNameToStack(mode, drawerName) {
    return (dispatch) => {
        dispatch({type: types.ADD_DRAWER_NAME, drawer: {mode, drawerName}});
    };
}

export function removeDrawerNameToStack() {
    return (dispatch) => {
        dispatch({type: types.REMOVE_DRAWER_NAME});
    };
}